module.exports = __webpack_public_path__ + "img/check-circle-green.7bea534b.svg";